module.exports = __webpack_public_path__ + "site_static/img/b1.c7a8bb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/b1.png
// module id = uj2L
// module chunks = 0